import { KeyValueModel } from "model";
import { EnumOcorrenciaRetorno } from "model/enums/enum-ocorrencia-retorno";

export const OcorrenciaRetornoMock: KeyValueModel[] = [
    new KeyValueModel(EnumOcorrenciaRetorno.InclusaoAceita, "Inclusão Aceita"),
    new KeyValueModel(EnumOcorrenciaRetorno.AlteracaoAceita, "Alteração Aceita"),
    new KeyValueModel(EnumOcorrenciaRetorno.ExclusaoAceita, "Exclusão Aceita"),
    new KeyValueModel(EnumOcorrenciaRetorno.AutorizacaoAceita, "Autorização Aceita"),
    new KeyValueModel(EnumOcorrenciaRetorno.BloqueioAceito, "Bloqueio Aceito"),
    new KeyValueModel(EnumOcorrenciaRetorno.DesbloqueioAceito, "Desbloqueio Aceito"),
    new KeyValueModel(EnumOcorrenciaRetorno.InclusaoRejeitada, "Inclusão Rejeitada"),
    new KeyValueModel(EnumOcorrenciaRetorno.AlteracaoRejeitada, "Alteração Rejeitada"),
    new KeyValueModel(EnumOcorrenciaRetorno.ExclusaoRejeitada, "Exclusão Rejeitada"),
    new KeyValueModel(EnumOcorrenciaRetorno.AutorizacaoRejeitada, "Autorização Rejeitada"),
    new KeyValueModel(EnumOcorrenciaRetorno.BloqueioRejeitado, "Bloqueio Rejeitado"),
    new KeyValueModel(EnumOcorrenciaRetorno.DesbloqueioRejeitado, "Desbloqueio Rejeitado"),
    new KeyValueModel(EnumOcorrenciaRetorno.ConfirmacaoCompromissoAntecipadoFornecedor, "Confirmação Compromisso Antecipado Fornecedor"),
    new KeyValueModel(EnumOcorrenciaRetorno.CompromissoAntecipadoFornecedor, "Compromisso Antecipado Fornecedor"),
    new KeyValueModel(EnumOcorrenciaRetorno.DocTedDevolvido, "Doc/Ted Devolvido"),
    new KeyValueModel(EnumOcorrenciaRetorno.InsuficienciaFundos, "Insuficiência de Fundos"),
    new KeyValueModel(EnumOcorrenciaRetorno.BoletosRecusadosPorDivergenciaBase, "Boletos Recusados por Divergência Base"),
    new KeyValueModel(EnumOcorrenciaRetorno.NaoTemosMapeado1, "Não Temos Mapeado 1"),
    new KeyValueModel(EnumOcorrenciaRetorno.Devolucao, "Devolução"),
];